import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface NodeRowProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  /** Muted name at the left ("Period:", "A"). */
  label?: ReactNode
  labelClassName?: string
  /** The value beside the label: a connection pill, a status marker. Truncates. */
  children?: ReactNode
  /** Right-hand control or type ("Number"). Never shrinks. */
  trailing?: ReactNode
  /** The React Flow handle; CSS centres it on the node's border. */
  handle?: ReactNode
}

/**
 * One row of a backtest node. Inputs, parameters, outputs and the Switcher all
 * draw through it, so every row has the same height and spacing: the layout
 * variables on `.custom-node` in backtest-reactflow.css. e2e/node-gallery.spec.ts
 * measures every node type against them.
 */
export function NodeRow({
  label,
  labelClassName,
  children,
  trailing,
  handle,
  className,
  ...rest
}: NodeRowProps) {
  return (
    <div className={cn('node-row', className)} {...rest}>
      <span className="node-row__main">
        {label != null && label !== false && (
          <span className={cn('node-row__label', labelClassName)}>{label}</span>
        )}
        {children}
      </span>
      {trailing}
      {handle}
    </div>
  )
}
